import React from 'react'
import { ITeamMember } from '../types/operations.types'
import {
  OpsCard,
  OpsCardHeader,
  TeamMemberRow,
  TeamMemberInfo,
  StatusDot,
  UtilizationBar,
  opsColors,
} from '../styled/Operations.styled'

interface TeamPanelProps {
  members: ITeamMember[]
}

const statusColor = (status: ITeamMember['status']) => {
  switch (status) {
    case 'busy': return opsColors.successBase
    case 'waiting': return opsColors.warningBase
    case 'blocked': return opsColors.dangerBase
    case 'available': return opsColors.textFaded
    default: return opsColors.textFaded
  }
}

export const TeamPanel: React.FC<TeamPanelProps> = ({ members }) => {
  return (
    <OpsCard>
      <OpsCardHeader>
        <h3>Team</h3>
        <span style={{ fontSize: '12px', color: opsColors.textFaded }}>{members.length} members</span>
      </OpsCardHeader>
      {members.map((member) => (
        <TeamMemberRow key={member.id}>
          <StatusDot color={statusColor(member.status)} />
          <TeamMemberInfo>
            <div className="member-name">{member.name}</div>
            <div className="member-task">{member.currentTask || 'Available'}</div>
          </TeamMemberInfo>
          <UtilizationBar percent={member.utilization} />
        </TeamMemberRow>
      ))}
    </OpsCard>
  )
}
